export const activeKeyDetailPanels = {
    KEY_CANCELATIONS: '0',
    KEY_TESTS: '1',
    KEY_CALENDAR: '2',
    KEY_JUSTIFICATIONS: '3',
    KEY_MATERIALS: '4',
    KEY_EVENTS: '5',
};
